var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mt-4 px-3 py-4"},[_c('p',[_vm._v("- Note:")]),_c('ul',_vm._l((Object.entries(_vm.metrics)),function(metric){return _c('li',{key:metric[0]},[_c('p',[_vm._v(_vm._s(metric[0])+": "+_vm._s(metric[1]))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }